import { CustomElement, resolve } from 'aurelia';
import { AccountService, AdminService, CalendarService } from '../../services';
import template from './account-menu.html';

// Header account control for non-admin visitors: a Sign in button when signed out, or an
// avatar dropdown (identity, Profile, Sign out) when signed in. Shown only when user login is
// configured and the admin menu is not active. State and actions live in AccountService; the
// sign-in disabled state tracks the initial CalendarService load.
export class AccountMenuElement {
  readonly account: AccountService = resolve(AccountService);
  readonly admin: AdminService = resolve(AdminService);
  readonly calendar: CalendarService = resolve(CalendarService);
}

export const AccountMenu = CustomElement.define({
  name: 'account-menu',
  template,
  // Render in place so the absolutely-positioned .account-menu keeps its header anchor.
  containerless: true
}, AccountMenuElement);
